import { EmployeeListPage } from "@/features/employee/pages/EmployeeList";

const EmployeeList = () => {
  return <EmployeeListPage />;
};

export default EmployeeList;
